// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { pagination, search, filters} = params

    const { sortBy, sortDesc, page, itemsPerPage } = pagination
      ? pagination
      : [null, null, null, null];

    const sort = [];
    if(sortBy && sortDesc && sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }
    if(search){
      filters.search = search
    }

    return new Promise(resolve => {
      NewApiService.get("shipping", {
        page: page,
        sort: sort.join(","),
        rowsPerPage: itemsPerPage,
        filter: filters
      })
        .then(({ data }) => {
          context.commit("set_shippings", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  list(context) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("shipping")
          .then(({ data }) => {
            context.commit("set_shippings", data);
            context.commit("unset_loading");
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
    });
  },
  view(context, id) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get(`shipping/${id}`)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("shipping", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("shipping/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data)
        });
    });
  },
  toggle(context, {model}) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("shipping/" + model.id, { enabled: !model.enabled})
          .then(({ data }) => {
            context.commit("unset_loading");
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response.data)
          });
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("shipping/" + params.model.id)
          .then(({ data }) => {
            context.commit("unset_loading");
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response.data)
          });
    });
  }
};
